import { normalizeInsightsPayload } from './insights-schema';

export function extractFirstJSONObject(text: string): string | null {
  const start = text.indexOf('{');
  if (start < 0) return null;
  let depth = 0, inStr = false, esc = false;
  for (let i = start; i < text.length; i++) {
    const c = text[i];
    if (inStr) {
      if (!esc && c === '"') inStr = false;
      esc = !esc && c === '\\';
      continue;
    }
    if (c === '"') { inStr = true; continue; }
    if (c === '{') depth++;
    if (c === '}') { depth--; if (depth === 0) return text.slice(start, i + 1); }
  }
  return null;
}

export function handleInsightPayload(rawTextOrObj: unknown) {
  const obj = typeof rawTextOrObj === 'string'
    ? JSON.parse(extractFirstJSONObject(rawTextOrObj) || '{}')
    : (rawTextOrObj as any);
  const data = normalizeInsightsPayload(obj);
  // Relaxed: accept any non-empty caption; fallback only if empty
  const hasCaption = String(data.figure_caption || '').trim().length > 0;
  if (!hasCaption) {
    const firstTitle = Array.isArray(data.insights) && data.insights[0] ? String(data.insights[0].title || '') : '';
    const fallback = firstTitle
      ? `${firstTitle}`
      : 'Figure summarizing results; see results and next steps below.';
    (data as any).figure_caption = fallback;
  }
  return data;
}

// Safe normalizer used by chat render paths to guarantee consistent shape
export function safeNormalizeInsightsPayload(raw: any): {
  schema_version: 'insight.v2';
  figure_caption: string;
  insights: Array<{ title: string; body: string }>;
  next_steps: string[];
} {
  try {
    const data = normalizeInsightsPayload(raw as any);
    return {
      schema_version: 'insight.v2',
      figure_caption: String(data.figure_caption || ''),
      insights: Array.isArray((data as any).insights) ? (data as any).insights : [],
      next_steps: Array.isArray((data as any).next_steps) ? (data as any).next_steps.map((s: any) => String(s)).filter(Boolean) : [],
    };
  } catch {
    return { schema_version: 'insight.v2', figure_caption: '', insights: [], next_steps: [] };
  }
}


